


































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { NewsDetail, SearchCondition } from '@/modules/admin/news';
import { School } from '@/models/school';
import { ElForm } from 'element-ui/types/form';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class NewsList extends Vue {
  private showSearchCondition = true;

  private customToolbar = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered'}, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1'}, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link']
  ];

  private formRule = {
    title: [
      { required: true, message: 'タイトルを入力してください' },
    ],
    note: [
      { required: true, message: '内容を入力してください' },
    ],
  };

  private deleteFormRule = {
    checkYes: [
      { required: true, message: `削除する場合は「はい」を入力してください` },
      {
        pattern: '^はい$',
        message: `削除する場合は「はい」を入力してください`,
        trigger: 'blur'
        },
    ],
  };

  get loading(): boolean {
    return this.$store.state.adminNews.loading;
  }

  get countAll(): number {
    if (this.$store.state.adminNews.countAll === 0) {
      return 1;
    } else {
    return this.$store.state.adminNews.countAll;
    }
  }

  get news(): NewsDetail[] {
    return this.$store.state.adminNews.newsList;
  }

  get condition(): SearchCondition {
    return this.$store.state.adminNews.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['adminAuth/userType']) {
      case UserTypes.Admin:
        next();
        break;
      default:
        next({ name: 'AdminError' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('adminNews/searchNews', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private publicationDateFormatter(row: NewsDetail) {
    if (!row.publicationDate) {
      return '';
    } else {
      return (this as any).$moment(row.publicationDate).format('YYYY/MM/DD');
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.newsEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onCreate() {
    this.$router.push({ name: 'AdminNewsCreate' });
  }

  private async onEdit(row: NewsDetail) {
    this.$router.push({
      name: 'AdminNewsEdit',
      params: {
        newsId: row.id,
      }
    });
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.newsDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDelete(row: NewsDetail) {
    try {
      const form = {
        title: row.title,
        checkYes: '',
      };
      await (this.$refs.newsDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminNews/deleteNews', row.id);
      this.$notify({
        title: 'お知らせ削除完了',
        message: `お知らせを削除しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'お知らせ削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }
}
